import React from 'react';

import {ConfirmationModalData} from 'models/Modal';
import {Routes} from 'models/Navigation';

import {navigate as baseNavigate, goBack} from './navigation';

/**
 * Global Modal System
 * Confirmation Modal: Manually use showConfirmationModal or use the
 *    ConnectedConfirmationModalTrigger component, depending on your needs
 */
export class ModalServiceClass {
  private _confirmationModalData: ConfirmationModalData | undefined;
  get confirmationModalData(): ConfirmationModalData | undefined {
    return this._confirmationModalData;
  }
  private _confirmationModalPromise: Promise<boolean> | undefined;
  private _confirmationModalPromiseHandler?: (isConfirmed: boolean) => void;

  /**
   * Displays a Confirmation Modal with the given data
   * @returns A promise that resolves when the user closes the modal. Resolves as true if confirmed,
   *   false if canceled
   */
  showConfirmationModal(
    data: ConfirmationModalData,
    navigate = baseNavigate
  ): Promise<boolean> {
    this._confirmationModalData = data;
    this._confirmationModalPromise = new Promise<boolean>(
      resolve => (this._confirmationModalPromiseHandler = resolve)
    );

    navigate(Routes.Modal.StackName, {
      screen: Routes.Modal.ConfirmationModal,
    });

    return this._confirmationModalPromise;
  }

  /**
   * Close the current confirmation modal with the isConfirmed flag
   * ConnectedConfirmationModal does this automatically on the confirm/cancel buttons but you could
   * use this to close programmatically as well
   */
  closeConfirmationModal(isConfirmed: boolean) {
    if (this._confirmationModalPromiseHandler) {
      this._confirmationModalPromiseHandler(isConfirmed);
    }

    this._confirmationModalPromiseHandler = undefined;
    this._confirmationModalPromise = undefined;
    this._confirmationModalData = undefined;

    goBack();
  }
}

export const ModalService = new ModalServiceClass();
export const ModalContext =
  React.createContext<ModalServiceClass>(ModalService);
export const ModalProvider = ModalContext.Provider;
